<template>
  <div class="page-wrapper page-repair-apply">
    <!-- 如何查询IMEI码 -->
    <ImeiLookupDialog :visible="queryimeiVisible" @dialog-cancel="queryimeiVisible = false" />
    <section class="service-sendrepair-apply">
      <div class="sendrepair-apply-title">寄修服务申请</div>
      <div class="tips">为了保护您的个人隐私和财产安全，请您务必在产品送检前备份并删除个人重要数据、解除设备绑定和清除解锁密码，以免数据丢失或泄露。</div>
      <el-form
        :model="formData"
        :rules="rulesFrom"
        ref="applyFrom"
        class="sendrepair-apply-from"
        @submit.native.prevent
      >
        <div class="form-item-block">
          <el-form-item prop="imeiOrSn">
            <div class="basicinfor-title">填写设备信息</div>
            <el-input
              @blur="getInfro"
              class="equipmentInfor-input"
              v-model.trim="formData.imeiOrSn"
              placeholder="请输入10-30位IMEI号或SN码"
            ></el-input>
            <span class="queryIMEI" @click="queryimeiVisible = true">
              <span class="ruhe">如何查询IMEI/SN</span>
              <img src="imgs/queryiemi-icon.svg" />
            </span>

            <ul class="imei-info" v-if="isimeiInfo">
              <li>状态：{{ getOverdue(imeiInfo.isOverdue)}}</li>
              <li>机型: {{ imeiInfo.model }}</li>
              <li>IMEI/SN号：{{ imeiInfo.imeiOrSn }}</li>
              <li>预估保修截止日期：{{ +imeiInfo.isEstimated === 1 ? '待更新' : imeiInfo.endTimeStr.slice(0, 10) }}
                <div class="label-tip" v-if="+imeiInfo.isEstimated === 1">(新购机用户正常使用3至5天后再查看)</div>
              </li>
            </ul>
          </el-form-item>
        </div>

        <div class="form-item-block">
          <el-form-item prop="faultTypeList">
            <div class="basicinfor-title">选择故障类型</div>
            <el-checkbox-group
              class="faultType-checkbox"
              v-model="formData.faultTypeList"
              size="medium"
              fill="#45C98E"
            >
              <el-checkbox
                v-for="(fault, index) in faultTypes"
                :key="index"
                border
                :label="fault.id"
              >{{ fault.category }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item prop="faultDetails">
            <el-input
              type="textarea"
              maxlength="100"
              show-word-limit
              :rows="6"
              placeholder="描述您的故障详情（必填）"
              v-model.trim="formData.faultDetails"
            ></el-input>
          </el-form-item>
        </div>

        <div class="form-item-block">
          <el-form-item prop="faultImgUrls" >
              <div class="basicinfor-title">上传机器图片</div>
              <div
                class="image-describe"
              >上传机器图片，单张图片大小不超过6M，最多10张（支持png、jpg、jpeg格式。请注意拍摄画质尽量清晰，突出机器故障问题。）</div>
              <div @click="toValidator">
                <ImgsUploadPreview v-model="formData.faultImgUrls" :imeiOrSn="formData.imeiOrSn" :disabled="!isimeiInfo" />
              </div>
              <el-dialog :visible.sync="dialogVisible" z-index="2000">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
          </el-form-item>
        </div>

        <div class="form-item-block">
          <div class="equipmentInfor-title">填写个人信息</div>
          <el-form-item label-width="6.77083vw" label="姓名" prop="username">
            <el-input class="name-input" v-model.trim="formData.username" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-row>
            <el-col :span="13">
              <el-form-item prop="phone" label="手机号" label-width="6.77083vw">
                <el-input class="phone-input" v-model.trim="formData.phone" placeholder="请输入手机号"></el-input>
                <el-button
                  class="send-code"
                  type="text"
                  @click="getCaptcha()"
                  :disabled="disabled"
                  v-if="disabled == false"
                >获取验证码</el-button>
                <span v-if="disabled" class="disabled-tip">{{ btntxt }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="captcha" label-width="6.77083vw" label="验证码">
                <el-input
                  class="sendcode-input"
                  v-model.trim="formData.captcha"
                  placeholder="请输入验证码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label-width="6.77083vw" label="所在区域" prop="area">
            <area-cascader
              class="form-area-selector"
              type="text"
              v-model.trim="formData.area"
              :data="pcaa"
              :level="1"
              style="width:100%"
              placeholder="省份/城市/区域/街道"
            ></area-cascader>
          </el-form-item>
          <el-form-item label-width="6.77083vw" label="详细地址" prop="site" style="margin-bottom:0">
            <el-input type="textarea" placeholder="请输入详细地址" v-model.trim="formData.site" :rows="6"></el-input>
          </el-form-item>
          <div class="address-remark">此地址用于维修商品寄回</div>
        </div>

        <el-form-item label-width="6.77083vw" prop="agree" >
          <div class="check-box" @click="agreeCheck">
            <div v-if="!checked" class="uncheck"></div>
            <img v-else src="../commons/assets/checked.png">
          </div>
          <span class="agree-remark">
            我已阅读并同意
            <a class="agree-a" href="repairProto.html" target="_blank">《奇少年寄修服务协议》</a>和
            <a class="agree-a" href="privacy.html" target="_blank">《隐私声明》</a>
          </span>
        </el-form-item>
        <el-form-item style="text-align:center;padding-bottom: 100px;">
          <el-button type="primary" @click.native.prevent="submitForm()">提交</el-button>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
import { pcaa } from 'area-data'
import ImgsUploadPreview from '../commons/components/ImgsUploadPreview.vue'
import ImeiLookupDialog from '../commons/components/ImeiLookupDialog.vue'
import { PATTERN } from "../commons/utils/constants";

export default {
  data() {
    var validateFaultDetails = (rule, value, callback)=>{
      if(value === ''){
        return callback(new Error('请输入您的故障详情'))
      }
      if(value.trim().length <5){
        return callback(new Error('描述故障详情字数不少于5个'))
      }
      if(value.trim().length >100){
        return callback(new Error('描述故障详情字数不多于100个'))
      }
      callback();
    }
    var validateFaultImgUrls = (rule, value, callback)=>{
      console.log('formData',this.formData);
      if(this.checkImeiV){
        callback();
      }else{
        return callback(new Error('请填写正确的IMEI或SN号'))
      }
    }
    return {
      pcaa: pcaa,
      disabled: false,
      time: 0,
      btntxt: "获取验证码",
      dialogImageUrl: "",
      dialogVisible: false,
      faultTypes: [],
      formData: {
        imeiOrSn: '',
        faultTypeList: [],
        faultDetails: "",
        faultImgUrls: [],
        username: "",
        phone: "",
        area: "",
        site: "",
        captcha: '',
        agree: []
      },
      checkImeiV:false,
      imeiInfo: {},
      isimeiInfo: false,
      uploading: false,
      loading: false,
      rulesFrom: {
        imeiOrSn: [
          { required: true, message: '请输入IMEI或SN号', trigger: 'blur' },
          // { pattern: /^\d{15}$/, message: 'IMEI号码必须是15位数字', trigger: 'blur' }
          { pattern: /^.{10,30}$/, message: 'IMEI或SN号必须是10-30位', trigger: 'blur' }
        ],
        faultTypeList: [
          { type: 'array', required: true, message: '请至少选择一个故障类型', trigger: 'change' }
        ],
        faultDetails:[
          // { required: true, message: '请输入您的故障详情', trigger: 'blur' },
          { validator: validateFaultDetails, trigger: 'blur' }
        ],
        faultImgUrls: [
          { validator: validateFaultImgUrls, trigger: 'blur' },
          { required: true, message: "请上传机器图片", trigger: "change" }
        ],
        username: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { pattern: PATTERN.phone, message: '请输入正确的手机号', trigger: 'blur' }
          // { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '验证码不能为空', trigger: ['blur', 'change'] },
          { pattern: /^\d{4}$/, message: '请输入正确的验证码', trigger: ['blur', 'change'] }
        ],
        area: [{ required: true, message: '请选择区域', trigger: 'change' }],
        site: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        agree: [
          { type: 'array', required: true, message: '请勾选同意', trigger: 'change' }
        ]
      },
      queryimeiVisible: false,
      checked: false
    }
  },

  components: {
    ImeiLookupDialog,
    ImgsUploadPreview
  },

  watch:{
    'formData.imeiOrSn'(){
      this.checkImeiV = false
    }
  },

  methods: {
    toValidator(){
      this.$refs.applyFrom.validateField('faultImgUrls',(val)=>{
        console.log('val',val);
      })
    },
    getInfro() {
      this.$refs.applyFrom.validateField('imeiOrSn', errMsg => {
        this.isimeiInfo = false
        this.checkImeiV = false
        if (!errMsg) {
          this.$request('post', '/repair-api/repair/repair-time-query', {
            imeiOrSn: this.formData.imeiOrSn
          }).then((res) => {
            this.imeiInfo = res.data
            this.imeiInfo.imeiOrSn = this.formData.imeiOrSn
            this.isimeiInfo = true
            this.checkImeiV = true
            this.toValidator()
          }).catch((res) => {
            this.$message({
              type: 'error',
              message: res.msg
            })
          })
        }
      })
    },

    getOverdue(overdue){
      if(overdue === 1){
        return "保修期内"
      }else if(overdue === 2){
        return "保修期外"
      }else if(overdue === 3){
        return "未激活"
      }
    },

    agreeCheck(){
      this.checked = !this.checked
      if(this.checked){
        this.$refs.applyFrom.clearValidate('agree')
      }
    },

    getFaultTypes() {
      this.$request('get', '/repair-api/fault/fault-type-query').then(resp => {
        this.faultTypes = resp.data
      })
    },

    onUploadSuccess(response) {
      if (response.code === 0) {
        this.formData.faultImgUrls.length < 10 && this.formData.faultImgUrls.push(response.data.url)
      } else {
        this.$message.error('图片上传失败！')
        this.uploading = false
      }
      this.uploading = false
    },

    onUploading() {
      this.uploading = true
    },

    onUploadError() {
      this.$message.error('图片上传失败！')
      this.uploading = false
    },

    onUploadExceed() {
      this.$message.error('上传图片总数将超过10张')
    },

    getCaptcha() {
      // 验证手机号是否正确
      this.$refs.applyFrom.validateField('phone', errMsg => {
        if (!errMsg) {
          this.$request('post', '/repair-api/sms/single', {
            phone: this.formData.phone
          }).then(() => {
            this.time = 60
            this.disabled = true
            this.timer()
          }).catch(err => {
            this.$message.error(err.msg)
          })
        }
      })
    },

    timer() {
      if (this.time > 0) {
        this.time--
        this.btntxt = "剩余" + this.time + "秒"
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = "获取验证码"
        this.disabled = false
      }
    },

    onPreviewImg(url) {
      this.dialogImageUrl = url
      this.dialogVisible = true
    },

    beforeUploadPicture(file) {
      if (this.formData.faultImgUrls.length >= 10) {
        return false
      }
      const isJPGPNG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/pjpeg"
      const isLt5M = file.size / 1024 / 1024 < 6;
      if (!isJPGPNG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 6MB!")
      }
      return isJPGPNG && isLt5M
    },

    submitForm() {
      console.log('this.$refs.applyFrom',this.$refs.applyFrom);
      if(this.checked) this.formData.agree.push(true)
      if(!this.checked) this.formData.agree = []
      this.$refs.applyFrom.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$request('post', '/repair-api/repair/order-add', {
            imeiOrSn: this.formData.imeiOrSn,
            faultTypeList: this.formData.faultTypeList,
            faultDetails: this.formData.faultDetails,
            faultImgUrls: this.formData.faultImgUrls.map(item => item.url),
            username: this.formData.username,
            phone: this.formData.phone,
            captcha: this.formData.captcha,
            area: this.formData.area.join('/'),
            site: this.formData.site
          }).then(resp => {
            this.$message.success('提交成功')
            localStorage.setItem('applyOrder', JSON.stringify(Object.assign(resp.data, {
              faultTypeList: resp.data.faultTypeList.map(faultId => {
                return this.faultTypes.find(item => faultId === item.id)
              })
            })))
            location.href = "repairApplySuccess.html"
          }).catch(err => {
            this.$message.error(err.msg)
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  },

  created() {
    this.getFaultTypes()
  }
}
</script>

<style lang="scss">
.page-repair-apply {
  .queryIMEI {
    cursor: pointer;
    display: inline-block;
    padding-left: 0.520833vw;
    box-sizing: border-box;
    text-align: left;

    .ruhe {
      vertical-align: middle;
      font-size: 0.833333vw;
      font-family: OPPOSans-R, OPPOSans;
      font-weight: normal;
      color: #31a9f8;
      line-height: 1.666667vw;
      padding-right: 4px;
    }

    img {
      vertical-align: middle;
      cursor: pointer;
    }
  }

  .imei-info {
    margin-top: 20px;
    margin-left: 30px;

    > li {
      font-size: 20px;
      font-family: OPPOSans-R, OPPOSans;
      font-weight: normal;
      color: rgba(31, 31, 31, 0.6);
      line-height: 32px;
    }

    .label-tip {
      color: #ffbb55;
    }
  }

  .service-sendrepair-apply {
    width: 62.5vw;
    margin: 0 auto;
    padding: 6.25vw 0;
  }
  .service-sendrepair-apply .sendrepair-apply-title {
    text-align: center;
    font-size: 1.875vw;
    font-family: OPPOSans-B, OPPOSans;
    font-weight: normal;
    color: #191919;
    line-height: 2.916667vw;
  }
  .tips{
    font-size: 1.4vw;
    font-family: OPPOSans-B, OPPOSans;
    font-weight: normal;
    color: #999999;
    line-height: 2.916667vw;
    margin-bottom: 0.875vw;
  }
  .sendrepair-apply-from .equipmentInfor-input {
    width: 36.979167vw;
  }

  .sendrepair-apply-from .image-describe {
    font-size: 1.041667vw;
    font-family: OPPOSans-R, OPPOSans;
    font-weight: normal;
    color: rgba(31, 31, 31, 0.4);
    margin-bottom: 0.520833vw;
  }
  .equipmentInfor-title {
    font-size: 1.25vw;
    font-family: OPPOSans-M, OPPOSans;
    color: #1f1f1f;
    margin-top: 3.125vw;
    margin-bottom: 1.041667vw;
  }
  .basicinfor-title {
    font-size: 1.25vw;
    font-family: OPPOSans-M, OPPOSans;
    color: #1f1f1f;
    margin-bottom: 1.041667vw;
  }

  .basicinfor-title::before {
    color: #ff6363;
    content: "*";
  }

  .send-code {
    cursor: pointer;
    font-size: 0.833333vw;
    font-weight: normal;
    color: #31a9f8;
    text-align: right;
  }
  .send-code.countdown {
    color: #ccc;
  }

  .area-cascader-wrap .area-select.large {
    width: 100%;
    height: 2.083333vw;
    line-height: 2.083333vw;
  }
  .area-cascader-wrap .area-select.large .area-selected-trigger {
    padding: 0;
    font-size: 0.729167vw;
    font-family: OPPOSans-R, OPPOSans;
    font-weight: normal;
    /* color: #ccc; */
    padding-left: 0.833333vw;
  }
  .check-box{
    display: inline-block;
    box-sizing: border-box;
    margin-right: 5px;
    vertical-align: top;
    >div{
      width: 16px;
      height: 16px;
      border: 0.5px solid #D5D5D5;
    };
    img{
      width: 20px;
      height: 20px;
    }
  }
  .agree-remark {
    font-size: 21px;
    font-family: OPPOSans-R, OPPOSans;
    font-weight: normal;
    color: rgba(31, 31, 31, 0.4);
    vertical-align: top;
  }
  .agree-a {
    color: #31a9f8;
    text-decoration: none;
  }

  .form-item-block {
    margin-bottom: 80px;
  }

  .el-checkbox.is-bordered.el-checkbox--medium {
    padding: 0 20px;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }

  .el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label {
    padding-left: 0;
    font-size: 16px;
  }

  .name-input.el-input {
    width: 420px;
  }
  .phone-input.el-input {
    width: 420px;
    margin-right: 10px;
  }

  .address-remark {
    font-size: 20px;
    font-family: OPPOSans-R, OPPOSans;
    font-weight: normal;
    color: rgba(31, 31, 31, 0.4);
    text-align: right;
    margin-top: 10px;
  }

  .form-area-selector {
    width: 100%;
    .area-select.large {
      width: 100%;
      height: 64px;
      line-height: 64px;
      vertical-align: middle;

      .area-selected-trigger {
        padding: 0;
        font-size: 24px;
        font-family: OPPOSans-R, OPPOSans;
        font-weight: normal;
        color: black;
        padding-left: 30px;
      }
    }
  }

  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-left: 0;
  }
  .el-checkbox.is-bordered.el-checkbox--medium {
    margin-bottom: 0;
    margin-top: 16px;
  }
  .el-form-item__label {
    font-size: 24px;
    font-family: OPPOSans-M, OPPOSans;
    color: #1f1f1f;
  }
  .el-button--primary {
    width: 160px;
    height: 48px;
    line-height: 48px;
    background: #45c98e;
    border-radius: 4px;
    border-color: #45c98e;
    font-size: 20px;
    font-family: OPPOSans-B, OPPOSans;
    font-weight: normal;
    padding: 0;
  }
  .el-button--primary:hover {
    background: #2BAD73;
    border-color: #2BAD73;
  }

  .imeiInfo-left {
    color: #aaa;
    font-size: 16px;
  }
  .imeiInfo-right {
    font-size: 18px;
    margin-left: 10px;
  }
  .faultType-checkbox .el-checkbox__input {
    display: none !important;
  }
  .el-checkbox.is-bordered.is-checked {
    border: 1px solid #45c98e;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #45c98e;
  }
  .el-checkbox--medium.is-bordered {
    margin-right: 16px;
  }
  .el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label{
    font-size: 24px;
  }

  .disabled-tip {
    font-size: 18px;
    color: #ccc;
  }

  .area-cascader-wrap {    
    .area-select {
      .cascader-menu-list {
        .cascader-menu-option.selected {
          color: #409EFF;
        }
      }
    }
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #45c98e;
    border-color: #45c98e;
  }

  .el-input__inner:focus,
  .el-textarea__inner:focus{
    border-color: #CDD5D2;
  }
}
</style>
